// import JSEncrypt from 'jsencrypt'
import NodeRSA from 'node-rsa-westartrack'
import store from '@/store'
import { mixQueue } from '@/lib/login-callbacks'
import { mixGetkey } from '@/services'
import { getMixAuth } from '@/lib/storage'
// import { notification } from 'ant-design-vue'
import { message as $message } from 'ant-design-vue'
import i18n from '@/lib/language'

const empty = data => data

let caches = ''
const getMixDomain = async () => {
  const hasBaseinfo = !!Object.keys(store.state.baseinfo).length
  if (!hasBaseinfo) {
    // await store.dispatch('permissionMenu')
    await new Promise(resolve => {
      setTimeout(resolve, 50)
    }).then(
      () => getMixDomain()
    )
  }
  return store.getters.mixDomain
}

const getLatestKeys = async () => {
  const mixDomain = await getMixDomain()
  const newKeys = await new Promise((resolve, reject) => {
    mixGetkey()
      .axiosConfig({
        baseURL: mixDomain
      })
      .config({
        async error403 () {
          const that = this
          await new Promise(async resolve => {
            // 设置登录或注册成功的回调函数
            mixQueue(async () => {
              await that.fetch()
            })
            // 显示弹窗
            await store.commit('mix/show')
          })
        }
      })
      .onRequest((config = {}) => {
        const auth = getMixAuth()
        if (auth) {
          config.headers['auth'] = auth
        }
        if (config.headers) {
          delete config.headers.Authorization
        }
        return config
      }, '#100')
      .onSuccess(res => {
        const { private: privateKey, public: publicKey } = res
        resolve({
          publicKey,
          privateKey
        })
      })
      .onNetFail(error => {
        reject(error)
      })
      .fetch()
  })
  return newKeys
}

let keysGetting = false
const loop = new Promise((resolve, reject) => {
  const func = () => {
    setTimeout(() => {
      if (caches) {
        resolve()
      } else {
        func()
      }
    }, 100)
  }
  return func()
})
const getKeys = async () => {
  if (!caches) {
    // 如果正在获取keys
    if (keysGetting) {
      await loop
    } else {
      keysGetting = true
      caches = await getLatestKeys()
      keysGetting = false
    }
  }
  return caches
}

const convert = (str) => {
  return str.split('').map(function (value, index, array) {
    var temp = value.charCodeAt(0).toString(16).toUpperCase()
    if (temp.length > 2) {
      return '\\u' + temp
    }
    return value
  }).join('')
}
const unconvert = (str) => {
  return unescape(str.replace(/\\/g, '%'))
}
export const decode = async str => {
  if (str && typeof str === 'string') {
    const mixDomain = await getMixDomain()
    if (mixDomain) {
      const { privateKey } = await getKeys()
      const decrypt = new NodeRSA(privateKey)
      // decrypt.setPrivateKey(privateKey)
      try {
        const result = decrypt.decrypt(str, 'utf8')
        return unconvert(result)
        // return unescape(result.replace(//g, '%'))
      } catch (err) {
        /* notification.error({
          message: '出错了',
          description: '数据解密失败'
        }) */
        $message.destroy()
        $message.error(i18n.t('message["1132"]'))
        return str
        // throw new Error('解密失败')
      }
    }
  }
  return str
}

export const getEncode = async () => {
  const mixDomain = await getMixDomain()
  try {
    if (mixDomain) {
      const { publicKey } = await getLatestKeys()
      const encrypt = new NodeRSA(publicKey)
      return async data => {
        if (data) {
          return encrypt.encrypt(convert(data), 'base64')
        } else {
          return data
        }
      }
    } else {
      return empty
    }
  } catch (err) {
    throw new Error(i18n.t('message["1153"]'))
  }
}
export const getDecode = async () => {
  const mixDomain = await getMixDomain()
  try {
    if (mixDomain) {
      const { privateKey } = await getLatestKeys()
      const decrypt = new NodeRSA(privateKey)
      return async str => {
        if (str && typeof str === 'string') {
          try {
            const result = decrypt.decrypt(str, 'utf8')
            return unconvert(result)
          } catch (err) {
            // notification.error({
            //   message: i18n.t('message["115"]'),
            //   description: i18n.t('message["1132"]')
            // })
            /* notification.error({
              message: '出错了',
              description: '数据解密失败'
            }) */
            $message.destroy()
            $message.error('数据解密失败')
            return str
            // throw new Error('解密失败')
          }
        } else {
          return str
        }
      }
    } else {
      return empty
    }
  } catch (err) {
    throw new Error(i18n.t('message["1153"]'))
  }
}
